export default __webpack_public_path__ + "static/media/delete.e29fa0fe.svg";